import { FC } from 'react';
import { Link as RebassLink } from '@rebass/emotion';

import { MAGENTO_URL } from '@config/client.config';
import cartSvg from '@app/assets/images/cart.svg';

import styles from './Cart.styles';

const Cart: FC = () => {
  return (
    <RebassLink css={styles.wrapper} href={`${MAGENTO_URL}/checkout/cart/`}>
      <img src={cartSvg} alt="checkout" css={{ maxWidth: 'unset' }} />
    </RebassLink>
  );
};

export default Cart;
